import { getConfiguration } from '@nuskin/configuration-sdk';
import { MySiteRestService } from "@nuskin/my-site-api";
import { UserService } from "@nuskin/ns-account";
import { ProductData } from '@nuskin/ns-product-lib';
import { ProductService, ShopContextService } from "@nuskin/ns-shop";
import { ProductDataService } from '@nuskin/ns-product';

import { equinoxLocalStorage, RunConfigService, SearchBarAdapter, events } from '@nuskin/ns-util';
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './ns-storefront-featured-products.html';

import '@polymer/iron-ajax/iron-ajax.js';
import '@polymer/iron-collapse/iron-collapse.js';
import '@polymer/iron-pages/iron-pages.js';
import '@polymer/paper-tabs/paper-tabs.js';


const SEARCH_TERM_KEY = "searchResultsData";

export class NsStorefrontFeaturedProducts extends PolymerElement {
    constructor() {
        super();
    }

    ready() {
        super.ready();
        this._removeSortOptionIfNotDistributor("pointHighToLow");
        this._removeSortOptionIfNotDistributor("pointLowToHigh");
    }

    connectedCallback() {
        super.connectedCallback();
        this.init();
    }

    static get is() {
        return "ns-storefront-featured-products";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get properties() {
        return {
            subdomain: {
                type: String,
                value: '',
                observer: '_overrideSubdomain'
            },
            translations: {
                type: Object,
                value: {
                    title: 'My Featured Products',
                    loadMore: 'Load More',
                    sortBy: 'Sort by',
                    notAvailable: 'Not Available for Purchase',
                    item: 'Item',
                    price: 'PRICE',
                    qty: 'QUANTITY',
                    purchase: 'ADD TO BAG',
                    choose: 'Choose {variant}',
                    select: 'Select',
                    points: 'Points',
                    psv: 'PSV'
                }
            },
            sortOptions: {
                type: Array,
                value: [
                    {
                        title: "Best Match",
                        sort: "best",
                        order: "best"
                    },
                    {
                        title: "A-Z",
                        sort: "title",
                        order: "asc"
                    },
                    {
                        title: "Z-A",
                        sort: "title",
                        order: "desc"
                    },
                    {
                        title: "Price (High to Low)",
                        sort: "price",
                        order: "asc"
                    },
                    {
                        title: "Price (Low to High)",
                        sort: "price",
                        order: "desc"
                    },
                    {
                        title: "Point Value (High to Low)",
                        sort: "pv",
                        order: "asc"
                    },
                    {
                        title: "Point Value (Low to High)",
                        sort: "pv",
                        order: "desc"
                    }
                ]
            },
            searchResultsNumber: {
                type: Number,
                notify: true,
                value: 0
            },
            skus: {
                type: Array,
                value: [],
                observer: "_onUpdateSkus"
            },
            selected: {
                type: Number,
                value: 0
            },
            searchResults: {
                type: Array,
                observer: '_updateResults',
                value: [{
                    "sectionTitle": "Products",
                    "resultsList": []
                }]
            },
            productPath: {
                type: String,
                value: '/content/nuskin/en_US/products/product.{sku}.storefront.html'
            },
            filterOptions: {
                type: Array,
                value: [
                    {
                        "category": "Filter Category 1",
                        "filters": [
                            {
                                "id": "filter1",
                                "label": "Filter 1"
                            },
                            {
                                "id": "filter2",
                                "label": "Filter 2"
                            },
                            {
                                "id": "filter3",
                                "label": "Filter 3"
                            }
                        ]
                    },
                    {
                        "category": "Filter Category 2",
                        "filters": [
                            {
                                "id": "filter1",
                                "label": "Filter 1"
                            },
                            {
                                "id": "filter2",
                                "label": "Filter 2"
                            },
                            {
                                "id": "filter3",
                                "label": "Filter 3"
                            },
                            {
                                "id": "filter4",
                                "label": "Filter 4"
                            },
                            {
                                "id": "filter5",
                                "label": "Filter 5"
                            },
                            {
                                "id": "filter6",
                                "label": "Filter 6"
                            }
                        ]
                    },
                    {
                        "category": "Filter Category 3",
                        "filters": [
                            {
                                "id": "filter1",
                                "label": "Filter 1"
                            },
                            {
                                "id": "filter2",
                                "label": "Filter 2"
                            },
                            {
                                "id": "filter3",
                                "label": "Filter 3"
                            }
                        ]
                    },
                    {
                        "category": "Filter Category 4",
                        "filters": [
                            {
                                "id": "filter1",
                                "label": "Filter 1"
                            },
                            {
                                "id": "filter2",
                                "label": "Filter 2"
                            },
                            {
                                "id": "filter3",
                                "label": "Filter 3"
                            },
                            {
                                "id": "filter4",
                                "label": "Filter 4"
                            }
                        ]
                    },
                    {
                        "category": "Filter Category 5",
                        "filters": [
                            {
                                "id": "filter1",
                                "label": "Filter 1"
                            },
                            {
                                "id": "filter2",
                                "label": "Filter 2"
                            }
                        ]
                    }
                ],
                notify: true,
                reflectToAttribute: true
            },
            isHorizontalCollapse: {
                type: Boolean,
                value: true
            },
            isAccordionClosed: {
                type: Boolean,
                value: false
            },
            cardType: {
                type: String,
                value: "short"
            },
            gridActive: {
                type: Boolean,
                value: true
            },
            rowActive: {
                type: Boolean,
                value: false
            },
            noChips: {
                type: Boolean,
                value: false
            },
            noSort: {
                type: Boolean,
                value: false
            },
            scroll: {
                type: Boolean,
                value: false
            },
            sortOptionSelected: {
                type: String,
                observer: "_sortOptionSelectedUpdated"
            },
            hideFilters: {
                type: Boolean,
                value: true
            },
            hideTabs: {
                type: Boolean,
                value: true
            },
            hideLayoutOptions: {
                type: Boolean,
                value: true
            },
            hideLoadMore: {
                type: Boolean,
                value: true
            },
            searchResultsPerPage: {
                type: Number,
                value: 36
            },
            srcNoResults: String,
            priceType: String,
            isEquinoxEnabled: {
                type: Boolean,
                value: false
            }

        };
    }

    init() {
        for (var i = 0; i < this.searchResults.length; i++) {
            if (i === 0) {
                this.set('searchResults.' + i + '.active', 'active');
            }
            else {
                this.set('searchResults.active', 'inactive');
            }
        }
        for (var i = 0; i < this.filterOptions.length; i++) {
            this.set('filterOptions.' + i + '.active', 'inactive');

            for (let j = 0; j < this.filterOptions[i]; j++) {
                this.set('filterOptions.' + i + '.' + j + '.checked', false);
            }
        }

        getCurrentFeaturedSkus().then(skus => this.set('skus', skus))
            .catch(console.error);

        let _this = this;
        _this.onResize();
        window.addEventListener("resize", function (e) {
            _this.onResize();
        });
    }

    _overrideSubdomain() {
        if (!this.subdomain) return;

        getCurrentFeaturedSkus(this.subdomain)
            .then(skus => this.set('skus', skus))
            .catch(console.error);
    }

    _sortOptionSelectedUpdated() {
        let index = this.sortOptionSelected[0];
        if (index >= 0) {
            let sort = this.sortOptions[index].sort;
            let order = this.sortOptions[index].order;
            this.sortBy(sort, order);
        }
    }

    _updateResults() {
        let results, productsArray = [];
        if (this.searchResults.length > 0) {
            results = this.searchResults[0].hasOwnProperty("resultsList") ? this.searchResults[0].resultsList.length : 0;
            this.searchResultsNumber = results;
            if (results > this.searchResultsPerPage) this.hideLoadMore = false;
        }
        let lazyLoad = this.shadowRoot.querySelector('#lazyLoad');
        if (lazyLoad) {
            lazyLoad.displayedResults = 0;
            lazyLoad.searchResultsPerPage = 36;
        }
        this.setLocalStorageResultsData();
        events.publish('closeSpinner');
    }

    async _onUpdateSkus(skus) {
        if (!skus || skus.length === 0) return;

        getConfiguration(["Equinox_Markets"]).then(async config => {
            const isEquinoxEnabledMarket = this.isEquinoxEnabled = config.Equinox_Markets.active && equinoxLocalStorage.isEquinoxEnabled();

            async function fetchProductDataInBatches(skus, batchSize = 6) {
                const results = [];
              
                for (let i = 0; i < skus.length; i += batchSize) {
                  const batch = skus.slice(i, i + batchSize);
                  try {
                    // console.log("(inside ns-storefront-featured-products) batch...............updated.....", batch);
                    const data = await ProductDataService.getProductData(batch);
                    // console.log("(inside ns-storefront-featured-products) data reponse...............", data.products[0]);
                    results.push(...data.products[0]);
                  } catch (err) {
                    console.log(err);
                  }
                }
              
                return results;
              }
              
              let promises = fetchProductDataInBatches(skus).then((products) => {
                return products.map((product) => {
                  if (isEquinoxEnabledMarket) {
                    return product;
                  } else {
                    if (product.isBase() && product.sku !== sku) {
                      return product.variants[sku];
                    } else {
                      return product;
                    }
                  }
                });
              }).catch(err => console.log(err));





            // Get product details for each SKU
            // let promises = skus.map(sku => {
            //     if (isEquinoxEnabledMarket) {
            //         return ProductDataService.getProductData(sku).then((data) => {
            //                 return data && data.products && data.products[0];
            //             }).catch(err => console.log(err));
            //     } else {
            //         return ProductDataService.getProductData(sku).then((data) => {
            //             if (data.products[0].isBase() && data.products[0].sku !== sku)
            //                 return data.products[0].variants[sku];
            //             else
            //                 return data.products && data.products[0];
            //         }).catch(err => console.log(err));
            //     }
            // }).map(p => p.catch(err => null)); // employ fallback for failed requests

            await this.setSearchResults(promises);
        })
    }

    async setSearchResults(productDataRequests) {
        try {
            let products = await Promise.all(productDataRequests);

            // Filter out fallback values from failed requests
            products = products.filter(p => !!p);

            const subdomain = this.subdomain || await MySiteRestService.getCurrentSubdomain();
            const subdomainPart = subdomain ? `.${subdomain}` : '';
            products.forEach(product => product.pdpUrl = `${this.productPath}.${product.sku}.mysite${subdomainPart}.html`);
            this.set('searchResults', SearchBarAdapter.adaptProductSearchResults(products));
        } catch (err) {
            console.error(err);
        }
    }

    lazyLoad() {
        let lazyLoad = this.shadowRoot.querySelector('#lazyLoad');
        lazyLoad.displayedResults = 0;
        lazyLoad.searchResultsPerPage += 36;
        if (lazyLoad.searchResultsPerPage > this.searchResults[0].resultsList.length) this.hideLoadMore = true;
        this.set('searchResults.0.resultsList.0.update', !this.searchResults[0].resultsList[0].update);
    }

    cardTypeLong() {
        this.set('cardType', 'long');
        this.set('gridActive', false);
        this.set('rowActive', true);
    }

    cardTypeShort() {
        this.set('cardType', 'short');
        this.set('gridActive', true);
        this.set('rowActive', false);
    }

    clearFilters() {
        this.shadowRoot.querySelectorAll('.filter-checkbox').forEach(function (el) {
            el.uncheck();
        });
    }

    closeAccordion() {
        for (let i = 0; i < this.filterOptions.length; i++) {
            this.set('filterOptions.' + i + '.active', 'inactive');
        }
        this.shadowRoot.querySelectorAll('.iron-collapse--panel').forEach(function (el) {
            el.hide();
        });

        if (!this.hideFilters) this.shadowRoot.querySelector('#collapse-accordion').hide();

    }

    onResize() {
        let width = document.documentElement.clientWidth;
        if (width < 768) {
            this.scroll = true;
            this.cardType = 'short';
            this.isHorizontalCollapse = false;
            this.closeAccordion();
        } else {
            this.scroll = false;
            this.isHorizontalCollapse = true;
            this.openAccordion();
        }
    }

    openAccordion() {
        for (let i = 0; i < this.filterOptions.length; i++) {
            this.set('filterOptions.' + i + '.active', 'inactive');
        }
        this.shadowRoot.querySelectorAll('.iron-collapse--panel').forEach(function (el) {
            el.hide();
        });
        if (!this.hideFilters) this.shadowRoot.querySelector('#collapse-accordion').show();

    }

    sortBy(sort, order) {
        for (let i = 0; i < this.searchResults.length; i++) {
            if (sort === "best") {
                this._onUpdateSkus(this.skus);
            } else {
                let resultsList = this.searchResults[i].resultsList.sort((a, b) => {
                    if (sort === "title") {
                        return (order === "desc") ? b[sort].localeCompare(a[sort]) : a[sort].localeCompare(b[sort]);
                    } else if (sort === "price") {
                        return (order === "desc") ? this._getPricingBasedOnLogin(a) - this._getPricingBasedOnLogin(b) : this._getPricingBasedOnLogin(b) - this._getPricingBasedOnLogin(a);
                    } else if (sort === "pv") {
                        return (order === "desc") ? this._getPSVBasedOnLogin(a) - this._getPSVBasedOnLogin(b) : this._getPSVBasedOnLogin(b) - this._getPSVBasedOnLogin(a);
                    } else {
                        return (order === "desc") ? sortValue(a[sort]) - sortValue(b[sort]) : sortValue(b[sort]) - sortValue(a[sort]);
                    }
                });
                this.set('searchResults.' + i + '.resultsList', []);
                this.set('searchResults.' + i + '.resultsList', resultsList);
            }
        }

        let lazyLoad = this.shadowRoot.querySelector('#lazyLoad');
        if (lazyLoad) {
            lazyLoad.displayedResults = 0;
        }
        this.set('searchResults.0.resultsList.0.update', !this.searchResults[0].resultsList[0].update);

        function sortValue(item) {
            if (typeof item === "undefined" || item === null) {
                return 0;
            }

            return item;
        }
    }

    _getPricingBasedOnLogin(productObject) {
        let priceType = "WRTL";
        let productPrice = 0;
        if (UserService.isLoggedIn()) {
            priceType = ShopContextService.getPriceType(false, UserService.getUser());
        }
        if (productObject) {
            if (productObject.hasOwnProperty("pricing") && productObject.pricing.length > 0) {
                productObject.pricing.map((item) => {
                    if (item.priceType === priceType) {
                        productPrice = item.price;
                    }
                });
            }
        }

        return productPrice;
    }

    _getPSVBasedOnLogin(productObject) {
        let priceType = "WRTL";
        let productPSV = 0;
        if (UserService.isLoggedIn()) {
            priceType = ShopContextService.getPriceType(false, UserService.getUser());
        }
        if (productObject) {
            if (productObject.hasOwnProperty("pvSet") && productObject.pricing.length > 0) {
                productObject.pvSet.map((item) => {
                    if (item.priceType === priceType) {
                        productPSV = item.pv;
                    }
                });
            }
        }

        return productPSV;
    }

    _removeSortOptionIfNotDistributor(sortOption) {
        if (this.translations) {
            let user = UserService.getUser();
            if ((!UserService.isLoggedIn() || !user.isDistributor()) && this.sortOptions) {
                for (let i = 0; i < this.sortOptions.length; i++) {
                    if (this.sortOptions[i].id === sortOption) {
                        this.sortOptions.splice(i, 1);
                    }
                }
            }
        }
    }

    toggleAccordion(state) {

        if (this.scroll) {
            this.shadowRoot.querySelector('#layout--header').scrollIntoView();
        }

        for (let i = 0; i < this.filterOptions.length; i++) {
            this.set('filterOptions.' + i + '.active', 'inactive');
        }
        this.shadowRoot.querySelectorAll('.iron-collapse--panel').forEach(function (el) {
            el.hide();
        });

        if (state && state === "close") {
            this.shadowRoot.querySelector('#collapse-accordion').hide();
        } else if (state === "open") {
            this.shadowRoot.querySelector('#collapse-accordion').show();
        } else {
            this.shadowRoot.querySelector('#collapse-accordion').toggle();
        }

    }

    toggleCheckbox(e) {
        e.model.set('filter.checked', false);
    }

    togglePanel(e) {
        let index = this.filterOptions.indexOf(e.model.item);
        this.shadowRoot.querySelector('#panel-collapse--' + index).toggle();
        (this.filterOptions[index].active === 'active') ? this.set('filterOptions.' + index + '.active', 'inactive') : this.set('filterOptions.' + index + '.active', 'active');
    }

    back() {
        events.publish('closeResultsPage');
    }

    setLocalStorageResultsData() {
        let searchResults = localStorage.getItem(SEARCH_TERM_KEY);
        if (!searchResults) {
            searchResults = {};
        } else {
            searchResults = JSON.parse(searchResults);
        }
        if (this.query) {
            searchResults.query = this.query;
        }
        if (this.searchResults && !$.isEmptyObject(this.searchResults)) {
            searchResults.searchResults = this.searchResults;
        }

        localStorage.setItem(SEARCH_TERM_KEY, JSON.stringify(searchResults));
    }

    resetLocaleStorageResultsData() {
        localStorage.removeItem(SEARCH_TERM_KEY);
    }

    checkLocalStorageResultsData() {
        let resultsData = localStorage.getItem(SEARCH_TERM_KEY);
        if (resultsData) {
            resultsData = JSON.parse(resultsData);
            this.query = resultsData.query;
            this.searchResults = resultsData.searchResults
        }

        this.resetLocaleStorageResultsData();
    }

    loadLimit() {
        if (this.searchResultsPerPage === undefined) this.searchResultsPerPage = 36;
        if (this.displayedResults === undefined) this.displayedResults = 0;
        if (this.displayedResults === this.searchResultsPerPage) return false;
        return ++this.displayedResults <= this.searchResultsPerPage;
    }

    productExists(product) {
        // This is for backward compatibility
        if (product.equinox === undefined) {
            return true;
        }

        return product.equinox.sku.exists;
    }
}

customElements.define(NsStorefrontFeaturedProducts.is, NsStorefrontFeaturedProducts);

/**
 * Retrieves featured product SKUs for a given My Site store.
 * @param {String} [subdomain] - My Site subdomain; if not provided, function attempts to use current subdomain
 * @returns {Promise.<Array.<String>>} Promise that resolves to array of SKU IDs
 * @ignore
 */
async function getCurrentFeaturedSkus(subdomain) {
    // If subdomain is not provided, attempt to find current subdomain
    if (!subdomain) subdomain = await MySiteRestService.getCurrentSubdomain();

    // Attempt to find sponsor ID; if none, default to market's featured products
    let sponsorId = await MySiteRestService.getCurrentSponsorId();
    if (!sponsorId) return getMarketFeaturedSkus();

    // Attempt to get sponsor; if none, default to market's featured products
    let sponsor = await MySiteRestService.getSponsorData(sponsorId);
    if (!sponsor || !sponsor.storefront) return getMarketFeaturedSkus();

    // if no subdomain has been found, default to sponsor's first subdomain
    if (!subdomain) subdomain = Object.keys(sponsor.storefront)[0];

    // Get store data for subdomain; if none, default to market's featured products
    let subdomainData = sponsor.storefront[subdomain] || {};
    let country = RunConfigService.getRunConfig().country;
    let storefrontData = subdomainData[country];
    if (!storefrontData) return getMarketFeaturedSkus();

    if (!storefrontData.showDefaultProducts && storefrontData.products) {
        return storefrontData.products;
    } else {
        return getMarketFeaturedSkus();
    }
}

/**
 * Retrieves featured product SKUs for the current market
 * @returns {Promise.<Array.<String>>} Promise that resolves to array of SKU IDs
 * @ignore
 */
async function getMarketFeaturedSkus() {
    let defaultFeaturedProducts = await MySiteRestService.getMarketFeaturedProducts();
    return defaultFeaturedProducts.map(p => p.sku);
}